import { centsToDollars } from "legacy/helpers.es6"
import SaleCheckoutItem from "legacy/sales/SaleCheckoutItem"
import PropTypes from "prop-types"
import React from "react"

class SaleCheckoutItemsList extends React.Component {
  constructor(args) {
    super(args)
    this.discountOptionsForItem = this.discountOptionsForItem.bind(this)
    this.renderItem = this.renderItem.bind(this)
    this.renderTotals = this.renderTotals.bind(this)
    this.displayForTotal = this.displayForTotal.bind(this)
  }

  discountOptionsForItem(item) {
    // Note: $context is loaded globally
    return ($context.discounts || []).filter((discount) =>
      discount.categories.includes(item.category)
    )
  }

  renderItem(item) {
    return (
      <div key={item.id}>
        <SaleCheckoutItem
          item={item}
          handleUpdateItemInCart={this.props.handleUpdateItemInCart}
          handleRemoveFromCart={this.props.handleRemoveFromCart}
          discountOptions={this.discountOptionsForItem(item)}
          invalidItems={this.props.invalidItems}
          showQuantityError={this.props.invalidQuantity.includes(item)}
          fetchedItem={(this.props.fetchedPricing.posItems || []).find(
            (posItem) => posItem.posItemTemplateId === item.id
          )}
          loadingPrices={this.props.loadingPrices}
        />
        <hr className="col-span-full my-2" />
      </div>
    )
  }

  renderTotals() {
    return (
      <div className="mt-4 grid grid-cols-2 rounded bg-gray-100 px-3 py-5">
        <p>Subtotal</p>
        <p className="text-right">
          {this.displayForTotal(this.props.fetchedPricing.subtotal)}
        </p>
        <hr className="col-span-full col-start-1 m-0 mb-1" />
        <p>Tax</p>
        <p className="text-right">
          {this.displayForTotal(this.props.fetchedPricing.taxAmount)}
        </p>
        <hr className="col-span-full col-start-1 m-0 mb-1" />
        <p>Total</p>
        <p className="text-right">
          {this.displayForTotal(this.props.fetchedPricing.totalPrice)}
        </p>
      </div>
    )
  }

  displayForTotal(price) {
    if (this.props.loadingPrices) {
      return <i className="fa-solid fa-spinner-third fa-spin text-gray-600" />
    } else if (price && this.props.items.length > 0) {
      return centsToDollars(price)
    } else {
      return "$0.00"
    }
  }

  render() {
    return (
      <div className="mt-2">
        {this.props.items.map(this.renderItem)}
        {this.renderTotals()}
        {this.props.pricingError && (
          <div className="flex items-center">
            <p className="p-3 text-red-700">{this.props.pricingError}</p>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.props.handleRetry()}
            >
              Retry
            </button>
          </div>
        )}
      </div>
    )
  }
}

SaleCheckoutItemsList.propTypes = {
  items: PropTypes.array.isRequired,
  handleUpdateItemInCart: PropTypes.func.isRequired,
  handleRemoveFromCart: PropTypes.func.isRequired,
  invalidItems: PropTypes.array,
  invalidQuantity: PropTypes.array,
  fetchedPricing: PropTypes.shape({
    posItems: PropTypes.array,
    subtotal: PropTypes.number,
    taxAmount: PropTypes.number,
    totalPrice: PropTypes.number,
  }),
  loadingPrices: PropTypes.bool,
  pricingError: PropTypes.string,
  handleRetry: PropTypes.func,
}

SaleCheckoutItemsList.defaultProps = {
  invalidItems: [],
  invalidQuantity: [],
  fetchedPricing: {
    posItems: [],
    subtotal: 0,
    taxAmount: 0,
    totalPrice: 0,
  },
  loadingPrices: false,
}

export default SaleCheckoutItemsList
